import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { admin, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#0B1220" }}>
        <div className="pg-mono text-[#00C2D6] text-xs tracking-[0.3em]">VERIFYING ACCESS...</div>
      </div>
    );
  }
  if (!admin) return <Navigate to="/staff-portal-72f4" replace />;
  return children;
}
